export default __webpack_public_path__ + "static/modal-1858d371dbcaa7d3457b944c31436b26.jpg";